import React from 'react';
import PropTypes from 'prop-types';
import css from './SignIn.css';
import ReadMoreLessText from '../common/ReadMoreLessText';
import SignInForm from './SignInForm';
import StyledButton from 'common/StyledButton';
import TextHeader from "./TextHeader";
import { SwipeCardConfigs } from "utils/types";
import PrivacyPolicyLink from 'common/PrivacyPolicyLink';
import TermsOfUseLink from 'common/TermsOfUseLink';
import KioskHeader from "./KioskHeader";

function SignIn(props) {
  
  return (
    <div>
      <KioskHeader name={props.kioskName}
                   showWaitTime={false}
                   setError={props.setError}
                   kioskImageUrl={props.kioskImageUrl} />
      <div className={css['content']}>
        <TextHeader
          upperText={props.greetingText}
          lowerText={props.mainHeader}
        />
        { props.instructionsText &&
          <div className={css['instructions']}>
            <ReadMoreLessText text={props.instructionsText}/>
          </div>
        }
        <SignInForm
          setError={props.setError}
          onSignIn={props.onSignIn}
          studentIdField={props.studentIdField}
          lastNameField={props.lastNameField}
          lastNameSignOnDisabled={props.lastNameSignOnDisabled}
          kioskId={props.kioskId}
          setLoginId={props.setLoginId}
          loginId={props.loginId}
          setStudentLastName={props.setStudentLastName}
          studentLastName={props.studentLastName}
          setWarning={props.setWarning}
          swipeCardConfigs={props.swipeCardConfigs}
          loadActiveXListener={props.loadActiveXListener}
          unloadActiveXListener={props.unloadActiveXListener}
          updateActiveXLastName={props.updateActiveXLastName}
        />
        {props.showToProspectiveStudents && <div className={css['extra']}>
          <div>{props.prospectiveStudentsText}</div>
          <StyledButton asLink onClick={props.goToProspectiveForm}>
            Sign in here.
          </StyledButton>
        </div>}
      </div>
      <div className={css['footer-container']}>
          <TermsOfUseLink />
          <PrivacyPolicyLink />
      </div>
    </div>
  );
}

SignIn.propTypes = {
  kioskId: PropTypes.number.isRequired,
  kioskName: PropTypes.string.isRequired,
  kioskImageUrl: PropTypes.string.isRequired,
  onSignIn: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  greetingText: PropTypes.string,
  mainHeader: PropTypes.string,
  instructionsText: PropTypes.string,
  prospectiveStudentsText: PropTypes.string,
  studentIdField: PropTypes.string.isRequired,
  lastNameField: PropTypes.string.isRequired,
  lastNameSignOnDisabled: PropTypes.bool.isRequired,
  showToProspectiveStudents: PropTypes.bool.isRequired,
  goToProspectiveForm: PropTypes.func.isRequired,
  setLoginId: PropTypes.func.isRequired,
  loginId: PropTypes.string.isRequired,
  setStudentLastName: PropTypes.func.isRequired,
  studentLastName: PropTypes.string.isRequired,
  setWarning: PropTypes.func.isRequired,
  swipeCardConfigs: SwipeCardConfigs.isRequired,
  loadActiveXListener: PropTypes.func,
  unloadActiveXListener: PropTypes.func,
  updateActiveXLastName: PropTypes.func
};

export default SignIn;
